export var StrokeCurveTypes = {
  smooth: 'spline',
  straight: 'line'
};
export var StrokeDashTypes = {
  dash: 'Dash',
  solid: 'Solid'
};

// format of data passed along for chartComponent
// groups all properties for the line UI in a single object

// used to type properly data passed along to highcharts